var windowWidth = window.innerWidth;
//搜索图标hover 展开搜索框
$(document).on("mouseover",".screenImg",function() {
    $(this).parent(".navLi").css("margin-left", "19px");
    $(".searchInp").css({
        "width": "165px",
        "padding-left": "10px"
    })
})
//关闭搜索框
$(document).on("click","body,.screenImg",function () {
    $(".searchInp").css({
        "width": "0px",
        "padding-left": "0px"
    })
    $(".navLi").last().css("margin-left","30px");
})
//输入框焦点清除冒泡
$(document).on("click",".searchInp",function (e) {
    e.stopPropagation();
})
//导航移入
$(document).on("mouseenter",".navLi",function () {
    $(this).find(".subNavUl").stop().animate({"height":"show"},500);
})
$(document).on("mouseleave",".navLi",function () {
    $(this).find(".subNavUl").stop().animate({"height":"hide"},500);
})
$(window).scroll(function(event) {
    var winPos = $(window).scrollTop();
    if(windowWidth>960){
        if (winPos < 600) {
            // $(".header").css("background", "rgba(1,30,58,0)");
        }
        if (winPos >= 600) {
            // $(".header").css("background", "rgba(1,30,58,.8)");
        }
    }
})
//web导航展开
$(document).on("click",".webNav",function () {
    $(this).toggleClass("navListZk");
    if($(this).hasClass("navListZk")){
        $(this).find(".webNavLine").eq(0).addClass("webNavLineXg1");
        $(this).find(".webNavLine").eq(1).css("width","0");
        $(this).find(".webNavLine").eq(2).addClass("webNavLineXg2");
        $(".webNavList").animate({"height":"show"},300);
    }else{
        $(this).find(".webNavLine").eq(0).removeClass("webNavLineXg1");
        $(this).find(".webNavLine").eq(1).css("width","100%");
        $(this).find(".webNavLine").eq(2).removeClass("webNavLineXg2");
        $(".webNavList").animate({"height":"hide"},300);
    }
})
$(document).on("click",".webNavLi",function () {
    if(!$(this).hasClass("navTwo")){
      $(".webNav").removeClass("navListZk").find(".webNavLine").eq(0).removeClass("webNavLineXg1");
      $(".webNav").find(".webNavLine").eq(1).css("width","100%");
      $(".webNav").find(".webNavLine").eq(2).removeClass("webNavLineXg2");
      $(".webNavList").animate({"height":"hide"},300);
    }
})
//web点击跳转后
$(document).on("click",".webNavLiTwoLi",function () {
    $(this).parents(".webNavLi").find(".webNavLiTop").removeClass("navZk").find("img").addClass("webImg");
    $(this).parent(".webNavLiTwoUl").animate({"height":"hide"},300);
    $(".webNav").removeClass("navListZk").find(".webNavLine").eq(0).removeClass("webNavLineXg1");
    $(".webNav").find(".webNavLine").eq(1).css("width","100%");
    $(".webNav").find(".webNavLine").eq(2).removeClass("webNavLineXg2");
    $(".webNavList").animate({"height":"hide"},300);
})
//web导航点击
$(document).on("click",".webNavLiTop",function () {
    if($(this).hasClass("navZk")){
        $(this).find("img").addClass("webImg");
        $(this).removeClass("navZk");
        $(this).parent().find(".webNavLiTwoUl").animate({"height":"hide"},300);
        return false;
    }
    $(".webNavLiTop").removeClass("navZk").find("img").addClass("webImg");
    $(".webNavLiTwoUl").animate({"height":"hide"},300);
    $(this).toggleClass("navZk");
    if($(this).hasClass("navZk")){
        $(this).find("img").removeClass("webImg");
        $(this).parent().find(".webNavLiTwoUl").animate({"height":"show"},300);
    }else{
        $(this).find("img").addClass("webImg");
        $(this).parent().find(".webNavLiTwoUl").animate({"height":"hide"},300);
    }
})
//html符号转义
function _htmlEncode(str) {
  var s = "";
  if ("" != str) {
    s = str.replace(/[<>&"'{}\[\/\\]/g, function(c) { return { '<': '&lt;', '#': '&yrfj', '>': '&gt;', '-': '&oline;', ';': '&dlkpl', '&': '&amp;', '"': '&quot;', "'": "&sbquo;", "{": "", "}": "", "[": "", "/": "&frasl;", "\\": "&nbsp;", "]": "" }[c]; });
    s = s.replace(/\r?\n/g, "");
  }
  return s;
}
//符号转义html
function _htmlDecode(str) {
  var isBr = arguments[1] ? true : false;
  var s = "";
  if (str == " ") {
    s = s.replace(" ", "&nbsp;");
  }
  if ("" != str) {
    s = str;
    s = s.replace(/&lt;/g, "<");
    s = s.replace(/&gt;/g, ">");
    s = s.replace(/&yrfj;/g, "#");
    s = s.replace(/&oline;/g, "-");
    s = s.replace(/&dlkpl;/g, ";");
    s = s.replace(/&frasl;/g, "\/");
    s = s.replace(/&sbquo;/g, "\'");
    s = s.replace(/&quot;/g, "\"");
    s = s.replace(/\<br \/\>/g, "<br />");
    s = s.replace(/&amp;/g, "&");
    //s = s.replace(/\s/g,"&nbsp;");
    if (isBr) {
      s = s.replace(/\<br \/\>/g, "\n");
    }
  }
  //s = s.replace(/\<br \/\>/g,"\n");
  return s;
}



// WEBPACK FOOTER //
// ./src/util/public.js